import type { AnalysisResults } from '../api/types';

/**
 * Which stage a PROCESSING run is in: `DATASETS` while it makes sure each source
 * cohort has a processed analytical dataset, then `CELLS` while it computes the
 * tables against those datasets. The dataset's rows are final from `CELLS` on.
 */
export type ProcessingStage = 'DATASETS' | 'CELLS';

/**
 * The stage of the run described by `results`, or null when it is not processing.
 * A processing run that reports no stage yet is in its first stage.
 */
export const getProcessingStage = (
  results: Pick<AnalysisResults, 'status' | 'stage'> | undefined
): ProcessingStage | null => {
  if (results?.status !== 'PROCESSING') return null;
  return results.stage === 'CELLS' ? 'CELLS' : 'DATASETS';
};
